import React, { Component } from 'react';
import RegisterForm from '../components/views/Login/RegisterForm';

export default RegisterForm;
